import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environment/environment';
import { FiltersListContabDto, InviaEmailContabDto, InviaMassivoResponse, ProtocolloEmailDto } from '../model/iscritti-data';
import { EtichetteFiltersDTO, RegistroComunicazioniDto, RicercaRegistroComunicazioniDto } from '../model/print-data';
import { PagedDataset } from '../model/filters-data';

@Injectable({
  providedIn: 'root'
})
export class PrintService {

  private _http = inject(HttpClient);

  private print_api: string = `${environment.printUrl}/jr`;
  private email_api: string = `${environment.printUrl}/email`;
  private registro_api: string = `${environment.baseUrl}/registro/comunicazioni`;

  stampaIscrizione(delibera: number, sezione: string, psi: boolean): Observable<any>{ // a / b / p
    return this._http.get(this.print_api + `/delibera-${psi ? "psi-" : ""}iscrizione-${sezione}/${delibera}`, { responseType: 'blob' });
  }

  stampaSchedaPersonale(idIscritto: number): Observable<any>{
    return this._http.get(this.print_api + `/scheda-personale/${idIscritto}`, { responseType: 'blob' });
  }

  stampaCertificatoIscrizione(idIscritto: number): Observable<any>{
    const endpoint = `/certificato-iscrizione/${idIscritto}`;
    return this._http.get(this.print_api + endpoint , { responseType: 'blob' });
  }

  stampaCertificatoIscrizioneEstero(idIscritto: number): Observable<any>{
    return this._http.get(this.print_api + `/certificato-iscrizione-estero/${idIscritto}`, { responseType: 'blob' });
  }

  stampaResocontoContabile(idIscritto: number): Observable<any>{
    return this._http.get(this.print_api + `/resoconto-contabile/${idIscritto}`, { responseType: 'blob' });
  }

  stampaCertificatoIscrizioneStp(idStp: number): Observable<any>{
    return this._http.get(this.print_api + `/certificato-iscrizione_stp/${idStp}`, { responseType: 'blob' });
  }

  emailNotificaIscrizione(idDelibera: number, data: ProtocolloEmailDto): Observable<boolean>{
    return this._http.post<boolean>(this.email_api + `/notifica-iscrizione/${idDelibera}`, data);
  }

  stampaTesserino(idIscritto: number): Observable<Blob> {
    return this._http.get(this.print_api + `/tesserino/${idIscritto}`, { responseType: 'blob' });
  }
  stampaTesserinoAlias(idIscritto: number): Observable<Blob> {
    return this._http.get(this.print_api + `/tesserino-alias/${idIscritto}`, { responseType: 'blob' });
  }

  stampaSollecitoQuote(idIscritto: number): Observable<Blob> {
    return this._http.get(this.print_api + `/sollecito-quote/${idIscritto}`, { responseType: 'blob' });
  }

  stampaSollecitoContributi(idIscritto: number): Observable<Blob> {
    return this._http.get(this.print_api + `/sollecito-contributi/${idIscritto}`, { responseType: 'blob' });
  }

  stampaEtichette(data: EtichetteFiltersDTO): Observable<Blob> {
    return this._http.post(this.print_api + `/etichette`, data, { responseType: 'blob' });
  }

  emailSollecitoQuota(data: InviaEmailContabDto): Observable<InviaMassivoResponse>{
    return this._http.post<InviaMassivoResponse>(this.email_api + `/sollecito-quota`, data);
  }
  emailSollecitoMulti(data: InviaEmailContabDto): Observable<InviaMassivoResponse>{
    return this._http.post<InviaMassivoResponse>(this.email_api + `/sollecito-multi`, data);
  }
  emailResocontoContabile(data: InviaEmailContabDto): Observable<InviaMassivoResponse>{
    return this._http.post<InviaMassivoResponse>(this.email_api + `/resoconto-contabile`, data);
  }

  ricercaRegistroComunicazioni(data: RicercaRegistroComunicazioniDto): Observable<PagedDataset<RegistroComunicazioniDto>>{
    return this._http.post<PagedDataset<RegistroComunicazioniDto>>(this.registro_api, data);
  }

}
